/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, ReactNode, useMemo } from 'react';

import { Tooltip, Typography, TypographyProps } from '@mui/material';

import { useTextTruncation } from '../utils/useTextTruncation';

type Props = {
  children: ReactNode;
} & TypographyProps;

export const TruncatableTypography = memo<Props>(props => {
  const text = useMemo(() => props.children?.toString() || '', [props.children]);
  const { isTextTruncated, textRef } = useTextTruncation(text);

  return (
    <Tooltip arrow title={isTextTruncated ? text : ''}>
      <Typography
        style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
        {...props}
        ref={textRef}
      >
        {props.children}
      </Typography>
    </Tooltip>
  );
});
